import React, { useState, useEffect, Component } from 'react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment/moment";
import { FaRegEye } from "react-icons/fa6";
import { AiOutlinePrinter } from "react-icons/ai";
import "../pagination/pagination.css";
import { IoAddSharp } from "react-icons/io5";
import Pagination from "../pagination/pagination";
import { GrEdit } from "react-icons/gr";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import { toast } from "react-toastify";
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL
const ProposalListing = () => {
    const [rowData, setRowData] = useState([]);
    const [proprtyList, setProperty] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loader, setloader] = useState(true);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [selectedRow, setSelectedRow] = useState(null);
    const apiService = new LeaseApiService();
    const [FilterTab, setFilterTab] = useState(true);
    const [contextMenu, setContextMenu] = useState(null);
    let navigate = useNavigate();
    const StatusFilter = [
        { value: "All", label: "All" },
        { value: "0", label: "Active" },
        { value: "1", label: "Renewed" },
        { value: "2", label: "Terminated" },
    ]
    const [formData, setFormData] = useState({
        email: "",
        Proprty: [{ label: "Select Property", value: "" }],
        Status: [{ label: "All", value: "" }],
        Unit: [{ label: "Select Unit", value: "" }],
        LeaseNo: [{ label: "Select Lease No", value: "" }],
    })

    useEffect(() => {
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, []);
    useEffect(() => {
        getItems();
    }, [])
    useEffect(() => {
        fetchDropdownData();
    }, [])
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append("dropdownTypes", "LPSerPropertyName");
            const res = await apiService.getApiParamater(
                "GET_DDLS_PROP",
                `?${params.toString()}`
            );
            setProperty(res?.data?.dropdowns?.LPSerPropertyName);
        } catch (error) {
            console.error("Error fetching dropdown data:", error);
        }
    }
    const handlePrint = (rowData) => {
        if (rowData?.leaseNo) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: "" },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                    { name: "ReceiptNo", value: "" },
                    { name: "reportName", value: 'LEASEPROPOSAL' },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const handleEye = (rowData) => {
        if (rowData?.leaseNo) {
            navigate(`/Property/Management/Lease/Proposal/${rowData?.leaseNo}`, { state: rowData });
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("PropertyName", formData?.Proprty?.label || "");
            params.append("Status", formData?.Status?.label || "");
            const res = await apiService.getApiParamater("GET_LEASE_PROP", `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2)
            ? 0
            : momentDate1.isBefore(momentDate2)
                ? -1
                : 1;
    }
    const columnDefs = [
        {
            headerName: '', field: 'leaseNo', cellRenderer: BtnCellRenderer, pinned: 'left',
            cellRendererParams: {
                clicked: function (field, leaseNo) {
                    handleMenuAction(field, leaseNo);
                },
            }, width: 30,
        },
        { headerName: "Status", field: "status", filter: true, floatingfilter: true, suppressMovable: true, width: 120, pinned: "left", },
        { headerName: "Lease No", field: "leaseNo", filter: true, floatingfilter: true, suppressMovable: true, width: 120, pinned: "left", },
        { headerName: "Period From", field: "leaseStart", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "Period To", field: "leaseEnd", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "Property", field: "propertyName", filter: true, floatingfilter: true, suppressMovable: true, width: 250, },
        { headerName: "Unit Num", field: "unitNo", filter: true, floatingfilter: true, suppressMovable: true, width: 100, },
        { headerName: "Unit Type", field: "unitType", filter: true, floatingfilter: true, suppressMovable: true, width: 100, },
        { headerName: "Account Code", field: "tenantNo", filter: true, floatingfilter: true, suppressMovable: true, width: 250, },
        { headerName: "Tenant", field: "tenantName", filter: true, floatingfilter: true, suppressMovable: true, width: 250, },
        { headerName: "Contact Num", field: "contactNo", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "Year Rent", field: "yearRent", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "Discount", field: "discount", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "Contract Value", field: "total", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "Rent", field: "rent", filter: true, floatingfilter: true, suppressMovable: true, width: 100, },
        { headerName: "VAT", field: "vat", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "Total", field: "total", filter: true, floatingfilter: true, suppressMovable: true, width: 100, },
        { headerName: "Tax", field: "tax", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "BedRooms", field: "tax1", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "Area", field: "totalArea", filter: true, floatingfilter: true, suppressMovable: true, width: 100, },
        { headerName: "Installments", field: "installments", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "Remarks", field: "remarks", filter: true, floatingfilter: true, suppressMovable: true, width: 180, },
        { headerName: "Modified", field: "modifiedBy", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "Contact From", field: "customerFrom", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "Modified On", field: "modifiedOn", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "Created By", field: "createdBy", filter: true, floatingfilter: true, suppressMovable: true, width: 140, },
        { headerName: "Created on", field: "createdOn", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
    ]
    const handlenew = () => {
        navigate("/Property/Management/Lease/Proposal/Add");
    }
    const handleEdit = async (rowData) => {
        if (rowData?.leaseNo) {
            try {
                setloader(true);
                navigate(`/Property/Management/Lease/Proposal/Edit`, { state: rowData });
            } catch (error) {
                setloader(false);
            }
        }
    }
    const handleAddAgreement = async (rowData) => {
        if (rowData?.leaseNo) {
            try {
                setloader(true);
                navigate(`/Property/Management/LeaseAgreement/proposal/${rowData?.leaseNo}`, { state: rowData });
            } catch (error) {
                setloader(false);
            }
        }
    }
    const handleClearFilters = () => {
        setFormData({
            Proprty: [{ label: "Select Property", value: "" }],
            Unit: [{ label: "Select Unit", value: "" }],
            LeaseNo: [{ label: "Select Lease No", value: "" }],
            Status: [{ label: "All", value: "" }],
        });
        getItems();
    }
    const handlePropertyChange = (selectedOption) => {
        setFormData({ ...formData, Proprty: selectedOption });
    }
    const handleStatusFilter = (selectedOption) => {
        if (selectedOption.label == "All") {
            handleClearFilters();
        } else {
            setFormData({ ...formData, Status: selectedOption });
        }
    }
    const handleMenuAction = (action, rowData) => {
        switch (action) {
            case 'view':
                handleEye(rowData);
                break;
            case 'edit':
                handleEdit(rowData);
                break;
            case 'print':
                handlePrint(rowData);
                break;
            case 'agreement':
                handleAddAgreement(rowData);
                break;
            default:
                break;
        }
        setContextMenu(null); // Close the menu
    }
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div
                        className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"
                            }`}
                    >
                        <div className="row">
                            <div className="col-4">
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData.Proprty}
                                    onChange={(selectedOption) =>
                                        handlePropertyChange(selectedOption)
                                    }
                                    options={proprtyList?.map((rec) => ({
                                        value: rec?.value,
                                        label: rec?.text,
                                    }))}
                                />
                            </div>
                            <div className="col-4">
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData.Status}
                                    options={StatusFilter}
                                    onChange={handleStatusFilter}
                                />
                            </div>
                            <div className="col-4 d-flex gap-1">
                                <div
                                    onClick={() => getItems()}
                                    className="mainbtnGry flex-end gap-2 w-50"
                                >
                                    <FaFileCircleExclamation
                                        color="#fff"
                                        className="center mt-1 mx-2"
                                    />
                                    <div className="center">Search</div>
                                </div>
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 p-4">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Lease Proposal List</h5>
                            <div className="d-flex justify-content-end gap-1">
                                <div className="col center">
                                    <button
                                        className="mainbtn "
                                        type="submit"
                                        onClick={() => handlenew()}
                                    >
                                        <IoAddSharp color="#fff" className="center mt-1" />{" "}
                                        <div>Add</div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="gridshad  mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: "#F0EDF5" };
                                        } else {
                                            return { background: "#fff" };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                    frameworkComponents={{ BtnCellRenderer }}
                                    context={{ setContextMenu }}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
            {contextMenu && (
                <div
                    style={{
                        position: 'absolute',
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        zIndex: 1000,
                        padding: '10px 10px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                    }}
                >
                    {(() => {
                        const { leaseNo, status } = contextMenu.data || {};
                        if (leaseNo) {
                            return (
                                <div style={{ display: 'grid' }}>
                                    <button className="btn btn-secondary " onClick={() => handleMenuAction('view', contextMenu.data)}>
                                        View
                                    </button>
                                    {status === "Leased" ? "" :
                                        <button className="btn btn-secondary mt-2" onClick={() => handleMenuAction('edit', contextMenu.data)}>
                                            Edit
                                        </button>}
                                    <button className="btn btn-secondary mt-2" onClick={() => handleMenuAction('print', contextMenu.data)}>
                                        Print
                                    </button>
                                    {status === "Proposed" ?
                                        <button className="btn btn-secondary mt-2" onClick={() => handleMenuAction('agreement', contextMenu.data)}>
                                            Create Lease Agreement
                                        </button> : ""}
                                </div>
                            );
                        }
                        return <div>No actions available</div>;
                    })()}
                </div>
            )}
        </div>
    );
};
class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // Prevent row selection
        const { context, data } = this.props;

        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.clientX,
                mouseY: e.clientY,
                data: data
            });
        }
    }

    render() {
        return (
            <div className='center'>
                <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '25px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}
export default ProposalListing;
